import Modal from "@/Organisms/Modals/Modal";
import {useEffect} from "react";
import Button from "@/Atoms/Input/Button";
import InputLabel from "@/Components/InputLabel";
import TextInput from "@/Components/TextInput";
import InputError from "@/Components/InputError";
import {useForm} from "@inertiajs/react";
import Select, {ListOption} from "@/Atoms/Select/Select";
import {relativeRoute} from "@/helpers/relativeRoute";
import axios, {AxiosError} from "axios";
import debounce from "@/helpers/debounce";


export default (
  {
    pendingOption,
    isVisible,
    onClose,
    onSubmit,
  }: {
    pendingOption: string
    isVisible: boolean
    onSubmit: (props: any) => void
    onClose: () => void
  }
) => {

  const { data, setData, errors, setError } = useForm<{
    country: any
    province?: any
    municipality?: any
    place: string
  }>({
    country: {
      type: 'country',
      value: 'land-nederland',
      label: 'Nederland'
    },
    place: pendingOption,
  });

  useEffect(() => {
    setData('place', pendingOption)
  }, [pendingOption]);

  const handleLoadOptions = debounce((inputValue: string, props: any) => {
    return new Promise<ListOption[]>(async (resolve) => {
      const response = await axios.get(relativeRoute('place-search'), {
        params: {
          search: inputValue,
          ...props
        }
      })
      resolve(response.data)
    });
  }, 500, {leading: true})


  const handleSubmit = async () => {
    try {
      const result = await axios.post(relativeRoute('places.add'), data)

      onSubmit(result.data)
    } catch (e: any) {

      const {message, errors} = ((e as AxiosError).response?.data as any)
      console.log(message)
      setError(errors)
    } finally {
      // setIsLoading(false)
    }
  }
  if (!isVisible)
  {
    return <></>
  }

  return <Modal title={`Nieuwe plaats toevoegen`} onCancel={() => onClose()}>
      <form data-test-id={'create-place-modal'}>

          <div>
              <InputLabel htmlFor="first_name" value="Land" required data-testid={'country'}/>
              <Select
                  dataTestid={'country'}
                  id="country"
                  isAsync
                  isCreatable
                  isClearable
                  loadOptions={(inputValue: string) => handleLoadOptions(inputValue, {
                    type: 'country'
                  })}
                  value={data.country ?? ''}
                  placeholder={'Zoek naar land of voeg toe'}
                  noOptionsMessage={() => 'Geen zoekresultaten'}
                  loadingMessage={() => 'Bezig met zoeken...'}
                  onChange={(place: any) => setData('country', place)}
              />
              <InputError message={errors.country} className="mt-2"/>
          </div>
        {data.country?.value === 'land-nederland' && <>
          <div>
              <InputLabel htmlFor="first_name" value="Provincie" required data-testid={'province'}/>
              <Select
                  dataTestid={'province'}
                  id="province"
                  isAsync
                  isClearable
                  loadOptions={(inputValue: string) => handleLoadOptions(inputValue, {
                    type: 'province',
                    country: data.country.value
                  })}
                  value={data.province ?? ''}
                  placeholder={'Zoek naar provincie'}
                  cacheOptions
                  noOptionsMessage={() => 'Geen zoekresultaten'}
                  loadingMessage={() => 'Bezig met zoeken...'}
                  onChange={(province: any) => setData({
                    ...data,
                    province: province,
                    municipality: null
                  })}
              />
              <InputError message={errors.province} className="mt-2"/>
          </div>

          <div>
              <InputLabel htmlFor="first_name" value="Gemeente" required data-testid={'municipality'}/>
              <Select
                  dataTestid={'municipality'}
                  id="municipality"
                  isAsync
                  cacheOptions
                  isClearable
                  loadOptions={(inputValue: string) => handleLoadOptions(inputValue, {
                    type: 'municipality',
                    country: data.country.value,
                    province: data.province.value
                  })}
                  value={data.municipality ?? ''}
                  placeholder={'Zoek naar gemeente of voeg toe'}
                  noOptionsMessage={() => 'Geen zoekresultaten'}
                  loadingMessage={() => 'Bezig met zoeken...'}
                  onChange={(municipality: any) => setData({
                    ...data,
                    municipality: municipality
                  })}
              />
              <InputError message={errors.municipality} className="mt-2"/>
          </div>
        </>}
          <div>
              <InputLabel htmlFor="first_name" value="Plaats" required data-testid={'place'}/>
              <TextInput
                  id="place"
                  value={data.place ?? ''}
                  onChange={(e: any) => setData('place', e.target.value)}
              />
              <InputError message={errors.place} className="mt-2"/>
          </div>


          <Button onClick={() => handleSubmit()}>Nieuwe plaats toevoegen</Button>

      </form>
  </Modal>
}
